import { render, staticRenderFns } from "./EmpzoneColForm.vue?vue&type=template&id=5de1817c&"
import script from "./EmpzoneColForm.vue?vue&type=script&lang=js&"
export * from "./EmpzoneColForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de1817c')) {
      api.createRecord('5de1817c', component.options)
    } else {
      api.reload('5de1817c', component.options)
    }
    module.hot.accept("./EmpzoneColForm.vue?vue&type=template&id=5de1817c&", function () {
      api.rerender('5de1817c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/empzone/col/modules/EmpzoneColForm.vue"
export default component.exports